import { FC } from 'react';
import { Center } from '@chakra-ui/react';

import getInitials from 'common/getInitials';
import Text from 'components/_core/Text';

interface InitialProps {
  name: string;
}

const Initial: FC<InitialProps> = ({ name }) => (
  <Center bg="grey.200" borderRadius="radius-8" boxSize="40px">
    <Text fontWeight="weight-500" variant="primary">
      {getInitials(name)}
    </Text>
  </Center>
);

export default Initial;
